/* OS EDD - Mix Bundle */
(function () {
  var ROOT_SELECTOR = '[data-os-edd-mix-bundle]';
  var BOGO_RELOAD_MARKER = '_osmb_bogo_reload';

  function qs(root, sel) {
    return root.querySelector(sel);
  }

  function qsa(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }

  function loadScriptOnce(src, attrName, attrValue, cb) {
    if (document.querySelector('script[' + attrName + '="' + attrValue + '"]')) {
      cb && cb();
      return;
    }

    var s = document.createElement('script');
    s.src = src;
    s.defer = true;
    s.setAttribute(attrName, attrValue);
    s.onload = function () {
      cb && cb();
    };

    document.head.appendChild(s);
  }

  function osjfOrdinal(n) {
    var s = ['th', 'st', 'nd', 'rd'];
    var v = n % 100;

    return s[(v - 20) % 10] || s[v] || s[0];
  }

  function osjfFormatDate(d) {
    var months = ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May.', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.'];
    var mm = months[d.getMonth()];
    var day = d.getDate();
    var yyyy = d.getFullYear();

    return mm + ' ' + day + osjfOrdinal(day) + ' ' + yyyy;
  }

  function initOSMB_OfferDates(root) {
    if (!root) return;

    var wrap = qs(root, '[data-osmb-offer-dates]');
    if (!wrap) return;

    if (wrap.dataset.osmbDatesInit === '1') return;
    wrap.dataset.osmbDatesInit = '1';

    var restockedEl = qs(root, '[data-osmb-restocked-date]');
    var selloutEl = qs(root, '[data-osmb-sellout-date]');
    if (!restockedEl || !selloutEl) return;

    var today = new Date();
    var restocked = today;
    var sellout = new Date(today.getTime() + (7 * 24 * 60 * 60 * 1000));

    restockedEl.textContent = osjfFormatDate(restocked);
    selloutEl.textContent = osjfFormatDate(sellout);
  }

  function initOSMB_OfferLottie(root) {
    if (!root) return;

    var iconEls = qsa(root, '[data-osmb-offer-lottie]');
    if (!iconEls.length) return;

    loadScriptOnce(
      'https://cdnjs.cloudflare.com/ajax/libs/lottie-web/5.12.2/lottie.min.js',
      'data-osmb-lottie-lib',
      '1',
      function () {
        if (!window.lottie) return;

        iconEls.forEach(function (iconEl) {
          var url = iconEl.getAttribute('data-lottie-url');
          if (!url) return;

          var container = iconEl.querySelector('.osmb-offer-box__callout-lottie');
          if (!container) return;

          if (iconEl.__osmbOfferLottieAnim) {
            try {
              iconEl.__osmbOfferLottieAnim.destroy();
            } catch (e) {}

            iconEl.__osmbOfferLottieAnim = null;
          }

          container.innerHTML = '';

          iconEl.__osmbOfferLottieAnim = window.lottie.loadAnimation({
            container: container,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: url,
            rendererSettings: {
              preserveAspectRatio: 'xMidYMid meet',
              progressiveLoad: true
            }
          });
        });
      }
    );
  }

  function toInt(v, fallback) {
    var n = parseInt(String(v || ''), 10);
    return isNaN(n) ? fallback : n;
  }

  function wait(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, ms);
    });
  }

  function postJSON(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload || {}),
      credentials: 'same-origin',
      cache: 'no-store'
    }).then(function (res) {
      var contentType = res.headers.get('content-type') || '';
      var isJson = contentType.indexOf('application/json') !== -1;

      return (isJson ? res.json() : res.text()).then(function (data) {
        if (!res.ok) {
          var msg =
            (data && (data.description || data.message)) ||
            (typeof data === 'string' ? data : 'Request failed');

          throw new Error(msg);
        }

        return data;
      });
    });
  }

  function parseVariantIdList(str) {
    var out = [];
    var raw = String(str || '').trim();
    if (!raw) return out;

    raw.split(/[,|\n]/g).forEach(function (part) {
      var p = String(part || '').trim();
      if (!p) return;

      var seg = p.split(':');
      var id = toInt(seg[0], 0);
      if (!id) return;

      var qty = 1;
      if (seg.length > 1) {
        qty = toInt(seg[1], 1);
        if (qty <= 0) qty = 1;
      }

      out.push({
        id: id,
        quantity: qty
      });
    });

    return out;
  }

  function parseDiscountCodes(str) {
    var raw = String(str || '').trim();
    var out = [];
    var seen = {};

    if (!raw) return out;

    raw.split(/[,|\n]/g).forEach(function (part) {
      var code = String(part || '').trim();
      var key = code.toLowerCase();

      if (!code || seen[key]) return;

      seen[key] = true;
      out.push(code);
    });

    return out;
  }

  function getDiscountCodesForTotal(total, d1, d2, d3) {
    var codes = [];

    if (total >= 1) codes = codes.concat(parseDiscountCodes(d1));
    if (total >= 2) codes = codes.concat(parseDiscountCodes(d2));
    if (total >= 3) codes = codes.concat(parseDiscountCodes(d3));

    var seen = {};
    var out = [];

    codes.forEach(function (code) {
      var key = String(code || '').toLowerCase();
      if (!key || seen[key]) return;

      seen[key] = true;
      out.push(code);
    });

    return out;
  }

  function getFreebieItemsForTotal(total, f1, f2, f3) {
    var freebies = [];

    if (total >= 1) freebies = freebies.concat(parseVariantIdList(f1));
    if (total >= 2) freebies = freebies.concat(parseVariantIdList(f2));
    if (total >= 3) freebies = freebies.concat(parseVariantIdList(f3));

    return freebies;
  }

  function mergeItems(baseItems, extraItems) {
    var map = {};
    var out = [];

    function keyOf(item) {
      var plan = item && item.selling_plan ? String(item.selling_plan) : '';
      return String(item && item.id ? item.id : '') + '::' + plan;
    }

    function addItem(item) {
      if (!item || !item.id || !item.quantity) return;

      var key = keyOf(item);

      if (!map[key]) {
        map[key] = {
          id: item.id,
          quantity: item.quantity
        };

        if (item.selling_plan) {
          map[key].selling_plan = item.selling_plan;
        }

        if (item.properties) {
          map[key].properties = item.properties;
        }

        out.push(map[key]);
      } else {
        map[key].quantity += item.quantity;
      }
    }

    (baseItems || []).forEach(addItem);
    (extraItems || []).forEach(addItem);

    return out;
  }

  function buildDiscountRedirectUrl(codes, redirectPath) {
    var list = (codes || []).filter(Boolean);
    if (!list.length) return '';

    return '/discount/' + encodeURIComponent(list.join(',')) + '?redirect=' + encodeURIComponent(redirectPath || '/checkout');
  }

  function normalizeBogoParamString(rawValue) {
    if (!rawValue) return '';

    var normalized = String(rawValue).trim();
    if (!normalized) return '';

    if (normalized.indexOf('://') !== -1) {
      try {
        normalized = new URL(normalized).search.replace(/^\?/, '');
      } catch (err) {}
    }

    var queryStartIndex = normalized.indexOf('?');
    if (queryStartIndex > -1) {
      normalized = normalized.slice(queryStartIndex + 1);
    }

    normalized = normalized.replace(/^[?&]+/, '');

    var hashIndex = normalized.indexOf('#');
    if (hashIndex > -1) {
      normalized = normalized.slice(0, hashIndex);
    }

    return normalized.trim();
  }

  function isInternalBogoParam(key) {
    return key === BOGO_RELOAD_MARKER;
  }

  function getBogoConfig(root) {
    return {
      enabled:
        !!root &&
        root.getAttribute('data-osmb-bogo-url-params-enabled') === 'true',
      params:
        root && root.getAttribute('data-osmb-bogo-url-params')
          ? root.getAttribute('data-osmb-bogo-url-params')
          : '',
      checkoutUrl:
        root && root.getAttribute('data-osmb-checkout-url')
          ? root.getAttribute('data-osmb-checkout-url')
          : '/checkout'
    };
  }

  function configuredBogoParamsMatchUrl(sanitizedParams) {
    var incoming = new URLSearchParams(sanitizedParams);
    var current = new URLSearchParams(window.location.search);
    var matches = true;

    incoming.forEach(function (value, key) {
      if (!key) return;

      if (current.get(key) !== value) {
        matches = false;
      }
    });

    return matches;
  }

  function mergeBogoParamsIntoUrl(baseUrl, sanitizedParams) {
    var mergedUrl = new URL(baseUrl, window.location.origin);
    var incomingParams = new URLSearchParams(sanitizedParams);
    var hasValidParam = false;

    incomingParams.forEach(function (value, key) {
      if (!key) return;

      mergedUrl.searchParams.set(key, value);
      hasValidParam = true;
    });

    return hasValidParam ? mergedUrl : null;
  }

  function stripInternalBogoParamsFromCurrentUrl() {
    var url = new URL(window.location.href);

    if (!url.searchParams.has(BOGO_RELOAD_MARKER)) return;

    url.searchParams.delete(BOGO_RELOAD_MARKER);

    var nextRelativeUrl =
      url.pathname + (url.search || '') + url.hash;

    window.history.replaceState({}, '', nextRelativeUrl);
  }

  function applyBogoUrlParams(root, options) {
    var config = getBogoConfig(root);
    var allowReload =
      !!(options && options.allowReload);

    if (!config.enabled) return false;

    var sanitizedParams =
      normalizeBogoParamString(config.params);

    if (!sanitizedParams) return false;

    if (configuredBogoParamsMatchUrl(sanitizedParams)) {
      stripInternalBogoParamsFromCurrentUrl();
      return false;
    }

    var mergedUrl = mergeBogoParamsIntoUrl(
      window.location.href,
      sanitizedParams
    );

    if (!mergedUrl) return false;

    if (allowReload) {
      var currentUrl = new URL(window.location.href);

      if (!currentUrl.searchParams.has(BOGO_RELOAD_MARKER)) {
        mergedUrl.searchParams.set(
          BOGO_RELOAD_MARKER,
          '1'
        );

        window.location.replace(mergedUrl.toString());
        return true;
      }
    }

    mergedUrl.searchParams.delete(BOGO_RELOAD_MARKER);

    var nextRelativeUrl =
      mergedUrl.pathname +
      (mergedUrl.search || '') +
      mergedUrl.hash;

    window.history.replaceState({}, '', nextRelativeUrl);

    return false;
  }

  function extractBogoCartAttributes(root) {
    var config = getBogoConfig(root);

    if (!config.enabled) return null;

    var sanitizedParams =
      normalizeBogoParamString(config.params);

    if (!sanitizedParams) return null;

    var attributes = {};
    var hasAny = false;

    new URLSearchParams(sanitizedParams).forEach(
      function (value, key) {
        if (!key || isInternalBogoParam(key)) return;

        attributes[key] = value;
        hasAny = true;
      }
    );

    return hasAny ? attributes : null;
  }

  function copyPublicSearchParams(sourceParams, targetUrl) {
    sourceParams.forEach(function (value, key) {
      if (!key || isInternalBogoParam(key)) return;

      targetUrl.searchParams.set(key, value);
    });
  }

  function mergeConfiguredBogoParams(checkoutUrl, root) {
    var config = getBogoConfig(root);

    if (!config.enabled) return;

    var sanitizedParams =
      normalizeBogoParamString(config.params);

    if (!sanitizedParams) return;

    new URLSearchParams(sanitizedParams).forEach(
      function (value, key) {
        if (!key || isInternalBogoParam(key)) return;

        checkoutUrl.searchParams.set(key, value);
      }
    );
  }

  function getCheckoutUrlWithCurrentParams(root) {
    var config = getBogoConfig(root);
    var checkoutUrl = new URL(
      config.checkoutUrl || '/checkout',
      window.location.origin
    );

    copyPublicSearchParams(
      new URLSearchParams(window.location.search),
      checkoutUrl
    );

    mergeConfiguredBogoParams(checkoutUrl, root);

    if (checkoutUrl.origin === window.location.origin) {
      return (
        checkoutUrl.pathname +
        checkoutUrl.search +
        checkoutUrl.hash
      );
    }

    return checkoutUrl.toString();
  }

  function fetchCart() {
    return fetch('/cart.js', {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin',
      cache: 'no-store'
    }).then(function (res) {
      if (!res.ok) {
        throw new Error(
          'Unable to read cart (' + res.status + ')'
        );
      }

      return res.json();
    });
  }

  function waitForBogoGift(knownItemCount) {
    return new Promise(function (resolve) {
      var elapsed = 0;
      var interval = 200;
      var maxWait = 3000;

      function checkCart() {
        fetchCart()
          .then(function (cart) {
            if (
              cart &&
              typeof cart.item_count === 'number' &&
              cart.item_count > knownItemCount
            ) {
              resolve(true);
              return;
            }

            elapsed += interval;

            if (elapsed >= maxWait) {
              resolve(false);
              return;
            }

            window.setTimeout(checkCart, interval);
          })
          .catch(function () {
            resolve(false);
          });
      }

      window.setTimeout(checkCart, interval);
    });
  }

  function getItemsQuantity(items) {
    return (items || []).reduce(function (total, item) {
      return (
        total +
        Math.max(1, toInt(item && item.quantity, 1))
      );
    }, 0);
  }

  function buildItemsFromState(state, planId, planMeta) {
    var items = [];
    var cleanPlanId = toInt(planId, 0);

    Object.keys(state.counts).forEach(function (variantId) {
      var qty = toInt(state.counts[variantId], 0);
      if (qty <= 0) return;

      var item = {
        id: toInt(variantId, 0),
        quantity: qty,
        properties: {
          _osmb_mix_bundle: '1'
        }
      };

      if (planMeta && planMeta.plan1) {
        item.properties._osmb_plan_1 = String(planMeta.plan1);
      }

      if (planMeta && planMeta.plan2) {
        item.properties._osmb_plan_2 = String(planMeta.plan2);
      }

      if (planMeta && planMeta.plan3) {
        item.properties._osmb_plan_3 = String(planMeta.plan3);
      }

      if (cleanPlanId) {
        item.selling_plan = cleanPlanId;
      }

      items.push(item);
    });

    return items;
  }

  function getScrollOffsetPx() {
    try {
      var header = document.querySelector('.header-wrapper');
      if (!header) return 0;

      var style = window.getComputedStyle(header);
      if (style.display === 'none' || style.visibility === 'hidden') return 0;

      var pos = (style.position || '').toLowerCase();
      if (pos !== 'fixed' && pos !== 'sticky') return 0;

      return Math.max(0, Math.round(header.getBoundingClientRect().height || 0));
    } catch (e) {
      return 0;
    }
  }

  function smoothScrollToTarget(targetEl) {
    if (!targetEl) return;

    var offset = getScrollOffsetPx();
    var rect = targetEl.getBoundingClientRect();
    var y = Math.round(window.pageYOffset + rect.top - offset - 12);

    window.scrollTo({
      top: Math.max(0, y),
      behavior: 'smooth'
    });
  }

  function setStickyVisible(root, isVisible) {
    var sticky = qs(root, '[data-osedd-sticky]');
    if (!sticky) return;

    if (isVisible) {
      root.classList.add('osedd-sticky-active');
      sticky.setAttribute('aria-hidden', 'false');
    } else {
      root.classList.remove('osedd-sticky-active');
      sticky.setAttribute('aria-hidden', 'true');
    }
  }

  function bindStickyObserver(root, mainCta) {
    if (!root || !mainCta || root.__osmbStickyObserved) return;

    var sticky = qs(root, '[data-osedd-sticky]');
    if (!sticky) return;

    root.__osmbStickyObserved = true;

    var flowersWrap = qs(sticky, '[data-osmb-sticky-flowers]');

    if (flowersWrap && !flowersWrap.hasChildNodes()) {
      var isMobileFlowers = window.matchMedia('(max-width: 899px)').matches;
      var flowerCount = isMobileFlowers ? 16 : 28;
      var flowerColors = [
        'is-pink',
        'is-yellow',
        'is-purple',
        'is-blue',
        'is-mint',
        'is-orange'
      ];

      for (var flowerIndex = 0; flowerIndex < flowerCount; flowerIndex += 1) {
        var flower = document.createElement('span');
        var useLeftSide = flowerIndex % 2 === 0;
        var flowerLeft = useLeftSide
          ? Math.random() * 30
          : 70 + Math.random() * 30;
        var flowerSize = isMobileFlowers
          ? 9 + Math.random() * 7
          : 11 + Math.random() * 10;
        var flowerDrift = -18 + Math.random() * 36;
        var flowerRotation = Math.random() > 0.5 ? 360 : -360;

        flower.className =
          'osedd-topshop__stickyFlower ' +
          flowerColors[flowerIndex % flowerColors.length];

        flower.style.left = flowerLeft.toFixed(2) + '%';

        flower.style.setProperty(
          '--osmb-sticky-flower-size',
          flowerSize.toFixed(2) + 'px'
        );

        flower.style.setProperty(
          '--osmb-sticky-flower-duration',
          (4.5 + Math.random() * 4).toFixed(2) + 's'
        );

        flower.style.setProperty(
          '--osmb-sticky-flower-delay',
          (-Math.random() * 9).toFixed(2) + 's'
        );

        flower.style.setProperty(
          '--osmb-sticky-flower-drift-x',
          flowerDrift.toFixed(2) + 'px'
        );

        flower.style.setProperty(
          '--osmb-sticky-flower-rotation',
          flowerRotation + 'deg'
        );

        flower.style.setProperty(
          '--osmb-sticky-flower-static-top',
          (12 + Math.random() * 76).toFixed(2) + '%'
        );

        flower.style.setProperty(
          '--osmb-sticky-flower-static-rotation',
          (-30 + Math.random() * 60).toFixed(2) + 'deg'
        );

        flowersWrap.appendChild(flower);
      }
    }


  if (flowersWrap && flowersWrap.children.length) {
    var iconStyle = flowersWrap.getAttribute('data-osmb-sticky-icon-style') || 'flowers';

    if (iconStyle !== 'flowers') {
      var customEmojis = (flowersWrap.getAttribute('data-osmb-sticky-emojis') || '')
        .split(/[,\n]+/)
        .map(function (emoji) { return emoji.trim(); })
        .filter(Boolean);
      var imageUrls = [1, 2, 3, 4]
        .map(function (slot) {
          return (flowersWrap.getAttribute('data-osmb-sticky-image-' + slot) || '').trim();
        })
        .filter(Boolean);
      var isMobileIcons = window.matchMedia('(max-width: 899px)').matches;
      var hasAvailableIcons = iconStyle === 'custom_emojis'
        ? customEmojis.length > 0
        : iconStyle === 'custom_images'
          ? imageUrls.length > 0
          : iconStyle === 'custom_mix'
            ? customEmojis.length > 0 || imageUrls.length > 0
            : true;

      if (!hasAvailableIcons) {
        flowersWrap.textContent = '';
      } else {
        Array.prototype.forEach.call(flowersWrap.children, function (flower, index) {
          var iconType = 'emoji';

          if (iconStyle === 'pumpkins') {
            iconType = 'pumpkin';
          } else if (iconStyle === 'ghosts') {
            iconType = 'ghost';
          } else if (iconStyle === 'halloween') {
            iconType = index % 4 < 2 ? 'pumpkin' : 'ghost';
          } else if (iconStyle === 'custom_images') {
            iconType = 'image';
          } else if (iconStyle === 'custom_mix') {
            iconType = customEmojis.length && (!imageUrls.length || index % 2 === 0)
              ? 'emoji'
              : 'image';
          }

          var contentIndex = iconStyle === 'custom_mix' && customEmojis.length && imageUrls.length
            ? Math.floor(index / 2)
            : index;
          var iconSize = isMobileIcons
            ? 16 + Math.random() * 8
            : 18 + Math.random() * 10;

          flower.className = 'osedd-topshop__stickyFlower is-' + iconType;
          flower.style.background = 'none';
          flower.style.display = 'flex';
          flower.style.alignItems = 'center';
          flower.style.justifyContent = 'center';
          flower.style.fontFamily = '"Apple Color Emoji", "Segoe UI Emoji", "Noto Color Emoji", sans-serif';
          flower.style.fontSize = iconSize.toFixed(2) + 'px';
          flower.style.lineHeight = '1';
          flower.style.whiteSpace = 'nowrap';
          flower.style.setProperty('--osmb-sticky-flower-size', iconSize.toFixed(2) + 'px');
          flower.style.setProperty('--osmb-sticky-flower-rotation', (-20 + Math.random() * 40).toFixed(2) + 'deg');
          flower.textContent = '';

          if (iconType === 'pumpkin' || iconType === 'ghost') {
            flower.textContent = iconType === 'pumpkin' ? '🎃' : '👻';
          } else if (iconType === 'emoji') {
            flower.textContent = customEmojis[contentIndex % customEmojis.length];
          } else if (iconType === 'image') {
            var image = document.createElement('img');
            image.src = imageUrls[contentIndex % imageUrls.length];
            image.alt = '';
            image.decoding = 'async';
            image.style.display = 'block';
            image.style.width = '100%';
            image.style.height = '100%';
            image.style.objectFit = 'contain';
            flower.appendChild(image);
          }
        });
      }
    }
  }

  var revealedCta = qs(root, '[data-osjf-cta]');

    var targets = [mainCta];
    if (revealedCta) targets.push(revealedCta);

    var inViewMap = {};
    var scrolledPastMap = {};
    targets.forEach(function (el, i) {
      inViewMap[i] = false;
      scrolledPastMap[i] = false;
    });

    function updateSticky() {
      var anyInView = false;
      var anyScrolledPast = false;
      targets.forEach(function (el, i) {
        if (inViewMap[i]) anyInView = true;
        if (scrolledPastMap[i]) anyScrolledPast = true;
      });
      // Show sticky only after at least one CTA has been scrolled past (is above viewport)
      // and no CTA is currently on screen
      setStickyVisible(root, !anyInView && anyScrolledPast);
    }

    if (!('IntersectionObserver' in window)) {
      var onScroll = function () {
        targets.forEach(function (el, i) {
          var r = el.getBoundingClientRect();
          inViewMap[i] = r.bottom > 0 && r.top < window.innerHeight;
          scrolledPastMap[i] = r.bottom < 0;
        });
        updateSticky();
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      onScroll();

      return;
    }

    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var i = targets.indexOf(entry.target);
          if (i === -1) return;
          inViewMap[i] = entry.isIntersecting && entry.intersectionRatio >= 0.25;
          scrolledPastMap[i] = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        });
        updateSticky();
      },
      {
        root: null,
        threshold: [0, 0.25, 0.5, 1]
      }
    );

    targets.forEach(function (el) { obs.observe(el); });
    root.__osmbStickyObs = obs;
  }

  function bindInfoDropdowns(root) {
    var items = qsa(root, '.osedd-topshop__infoItem');
    if (!items.length) return;

    items.forEach(function (item) {
      var btn = qs(item, '[data-osedd-info-btn]') || qs(item, '[data-osmb-info-btn]');
      var panel = qs(item, '[data-osedd-info-panel]') || qs(item, '[data-osmb-info-panel]');
      if (!btn || !panel) return;

      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        items.forEach(function (sib) {
          if (sib === item) return;

          sib.classList.remove('is-open');

          var sibBtn = qs(sib, '[data-osedd-info-btn]') || qs(sib, '[data-osmb-info-btn]');
          var sibPanel = qs(sib, '[data-osedd-info-panel]') || qs(sib, '[data-osmb-info-panel]');

          if (sibBtn) sibBtn.setAttribute('aria-expanded', 'false');
          if (sibPanel) sibPanel.hidden = true;
        });

        if (isOpen) {
          item.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
          panel.hidden = true;
        } else {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          panel.hidden = false;
        }
      });
    });
  }

  function placeCliniciansChoice(root) {
    if (!root) return;

    var badge = qs(
      root,
      '[data-osmb-clinicians-choice]'
    );

    var mobileMount = qs(
      root,
      '[data-osmb-clinicians-choice-mobile]'
    );

    var desktopMount = qs(
      root,
      '[data-osmb-clinicians-choice-desktop]'
    );

    if (!badge || !mobileMount || !desktopMount) return;

    var targetMount = window.matchMedia(
      '(max-width: 899px)'
    ).matches
      ? mobileMount
      : desktopMount;

    if (badge.parentElement !== targetMount) {
      targetMount.appendChild(badge);
    }
  }

  function bindCliniciansChoicePlacement(root) {
    if (!root) return;

    placeCliniciansChoice(root);

    if (root.__osmbCliniciansChoicePlacementBound) return;
    root.__osmbCliniciansChoicePlacementBound = true;

    var mediaQuery = window.matchMedia(
      '(max-width: 899px)'
    );

    var handleBreakpointChange = function () {
      placeCliniciansChoice(root);
    };

    if (
      typeof mediaQuery.addEventListener ===
      'function'
    ) {
      mediaQuery.addEventListener(
        'change',
        handleBreakpointChange
      );
    } else if (
      typeof mediaQuery.addListener === 'function'
    ) {
      mediaQuery.addListener(
        handleBreakpointChange
      );
    }
  }

  function bindRteScrollLinks(root) {
    bindCliniciansChoicePlacement(root);

    var containers = qsa(
      root,
      '.osedd-topshop__offerBody.rte'
    );

    if (!containers.length) return;

    containers.forEach(function (wrap) {
      wrap.addEventListener('click', function (e) {
        var a = e.target && e.target.closest ? e.target.closest('a') : null;
        if (!a) return;

        var href = (a.getAttribute('href') || '').trim();
        if (!href || href === '#' || href.charAt(0) !== '#') return;

        var id = href.slice(1);
        if (!id) return;

        var target = document.getElementById(id);
        if (!target) return;

        e.preventDefault();
        smoothScrollToTarget(target);

        try {
          history.pushState(null, '', '#' + id);
        } catch (err) {}
      });
    });
  }

  function clearRevealConfetti(root) {
    if (!root || !root.__osmbRevealConfetti) return;

    var active = root.__osmbRevealConfetti;

    if (active.rafId) {
      window.cancelAnimationFrame(active.rafId);
    }

    if (active.resizeHandler) {
      window.removeEventListener(
        'resize',
        active.resizeHandler
      );
    }

    if (active.canvas && active.canvas.parentNode) {
      active.canvas.parentNode.removeChild(active.canvas);
    }

    root.__osmbRevealConfetti = null;
  }

  function launchRevealConfetti(root, triggerButton) {
    if (!root) return;

    if (
      window.matchMedia &&
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches
    ) {
      return;
    }

    clearRevealConfetti(root);

    var canvas = document.createElement('canvas');
    var context = canvas.getContext('2d');

    if (!context) return;

    canvas.setAttribute('aria-hidden', 'true');
    canvas.style.cssText =
      'position:fixed;' +
      'inset:0;' +
      'width:100%;' +
      'height:100%;' +
      'pointer-events:none;' +
      'z-index:2147483646;';

    document.body.appendChild(canvas);

    var deviceScale = Math.min(
      window.devicePixelRatio || 1,
      2
    );

    function resizeCanvas() {
      canvas.width = Math.max(
        1,
        Math.floor(window.innerWidth * deviceScale)
      );
      canvas.height = Math.max(
        1,
        Math.floor(window.innerHeight * deviceScale)
      );

      context.setTransform(
        deviceScale,
        0,
        0,
        deviceScale,
        0,
        0
      );
    }

    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    var sourceButton =
      triggerButton ||
      qs(
        root,
        '[data-osmb-open-form]:not([data-osedd-sticky-cta])'
      );

    var sourceRect = sourceButton
      ? sourceButton.getBoundingClientRect()
      : null;

    var originX = sourceRect
      ? sourceRect.left + sourceRect.width / 2
      : window.innerWidth / 2;

    var originY = sourceRect
      ? sourceRect.top + sourceRect.height / 2
      : window.innerHeight / 2;

    var colors = [
      '#EC0287',
      '#F7C85B',
      '#9B6BFF',
      '#57C7FF',
      '#64D8B4',
      '#FF8A4C',
      '#FFFFFF'
    ];

    var particleCount =
      window.innerWidth <= 899 ? 78 : 112;

    var particles = [];

    for (
      var particleIndex = 0;
      particleIndex < particleCount;
      particleIndex += 1
    ) {
      var angle = Math.random() * Math.PI * 2;
      var speed = 220 + Math.random() * 430;
      var size = 5 + Math.random() * 7;

      particles.push({
        x: originX + (Math.random() - 0.5) * 18,
        y: originY + (Math.random() - 0.5) * 10,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed - 170,
        gravity: 760 + Math.random() * 360,
        drag: 0.982 + Math.random() * 0.008,
        rotation: Math.random() * Math.PI * 2,
        rotationSpeed:
          (Math.random() - 0.5) * 14,
        width: size,
        height: size * (0.45 + Math.random() * 0.8),
        color:
          colors[
            Math.floor(Math.random() * colors.length)
          ],
        shape: Math.random() > 0.8 ? 'circle' : 'rect',
        life: 0,
        maxLife: 1.15 + Math.random() * 0.75
      });
    }

    root.__osmbRevealConfetti = {
      canvas: canvas,
      rafId: null,
      resizeHandler: resizeCanvas
    };

    var previousTime = window.performance.now();

    function drawFrame(currentTime) {
      var deltaSeconds = Math.min(
        0.034,
        Math.max(0, currentTime - previousTime) / 1000
      );

      previousTime = currentTime;

      context.clearRect(
        0,
        0,
        window.innerWidth,
        window.innerHeight
      );

      var livingParticles = 0;

      particles.forEach(function (particle) {
        particle.life += deltaSeconds;

        if (particle.life >= particle.maxLife) return;

        livingParticles += 1;

        particle.vx *= Math.pow(
          particle.drag,
          deltaSeconds * 60
        );
        particle.vy *= Math.pow(
          particle.drag,
          deltaSeconds * 60
        );
        particle.vy +=
          particle.gravity * deltaSeconds;
        particle.x += particle.vx * deltaSeconds;
        particle.y += particle.vy * deltaSeconds;
        particle.rotation +=
          particle.rotationSpeed * deltaSeconds;

        var remaining =
          1 - particle.life / particle.maxLife;

        context.save();
        context.globalAlpha = Math.min(
          1,
          remaining * 2.8
        );
        context.translate(particle.x, particle.y);
        context.rotate(particle.rotation);
        context.fillStyle = particle.color;

        if (particle.shape === 'circle') {
          context.beginPath();
          context.arc(
            0,
            0,
            particle.width / 2,
            0,
            Math.PI * 2
          );
          context.fill();
        } else {
          context.fillRect(
            -particle.width / 2,
            -particle.height / 2,
            particle.width,
            particle.height
          );
        }

        context.restore();
      });

      if (livingParticles > 0) {
        root.__osmbRevealConfetti.rafId =
          window.requestAnimationFrame(drawFrame);
        return;
      }

      clearRevealConfetti(root);
    }

    root.__osmbRevealConfetti.rafId =
      window.requestAnimationFrame(drawFrame);
  }

  function openForm(root, triggerButton) {
    var offerView = qs(root, '[data-osmb-offer-view]');
    var formView = qs(root, '[data-osmb-form-view]');
    var card = qs(root, '[data-osmb-offer-card]');

    if (!offerView || !formView) return;
    if (root.classList.contains('is-form-open')) return;

    // Measure the clicked CTA while it is still visible.
    launchRevealConfetti(root, triggerButton);

    root.classList.add('is-form-open');

    offerView.hidden = true;
    formView.hidden = false;

    window.setTimeout(function () {
      smoothScrollToTarget(card || formView);

      var firstPlus = qs(root, '[data-osjf-plus]');
      if (firstPlus) firstPlus.focus({ preventScroll: true });
    }, 50);
  }

  function closeForm(root) {
    var offerView = qs(root, '[data-osmb-offer-view]');
    var formView = qs(root, '[data-osmb-form-view]');
    var mainCta = qs(root, '[data-osmb-open-form]:not([data-osedd-sticky-cta])');

    if (!offerView || !formView) return;

    root.classList.remove('is-form-open');

    offerView.hidden = false;
    formView.hidden = true;

    window.setTimeout(function () {
      smoothScrollToTarget(qs(root, '[data-osmb-offer-card]') || offerView);

      if (mainCta) mainCta.focus({ preventScroll: true });
    }, 50);
  }

  function initGallery(root) {
    var gallery = qs(root, '[data-osedd-gallery]');
    var mainSlides = qsa(root, '[data-osedd-gal-main-slide]');
    var thumbs = qsa(root, '[data-osedd-thumb]');
    var thumbViewport = qs(root, '[data-osedd-thumb-viewport]');
    var mainPrev = qs(root, '[data-osedd-main-nav="prev"]');
    var mainNext = qs(root, '[data-osedd-main-nav="next"]');

    if (qs(root, '.osedd-topshop__galThumbs')) {
      root.classList.add('osedd-has-thumbs');
    } else {
      root.classList.remove('osedd-has-thumbs');
    }

    if (!gallery || !mainSlides.length) return;

    var index = 0;

    function syncMainNav() {
      if (!mainPrev || !mainNext) return;

      var max = Math.max(0, mainSlides.length - 1);
      mainPrev.disabled = index <= 0;
      mainNext.disabled = index >= max;
    }

    function setActive(nextIndex) {
      var max = Math.max(0, mainSlides.length - 1);
      index = Math.min(Math.max(nextIndex, 0), max);

      mainSlides.forEach(function (slide, i) {
        var isActive = i === index;
        var slideVideos = qsa(slide, 'video');

        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');

        if (isActive) {
          slide.setAttribute('data-osedd-active', '1');
        } else {
          slide.removeAttribute('data-osedd-active');
        }

        slideVideos.forEach(function (video) {
          if (!isActive) {
            video.pause();
            return;
          }

          video.removeAttribute('muted');
          video.muted = false;
          video.defaultMuted = false;
          video.volume = 1;

          var playPromise = video.play();

          if (
            playPromise &&
            typeof playPromise.catch === 'function'
          ) {
            playPromise.catch(function () {});
          }
        });
      });

      thumbs.forEach(function (thumb, i) {
        var isActive = i === index;

        thumb.setAttribute('aria-selected', isActive ? 'true' : 'false');

        if (isActive) {
          thumb.setAttribute('data-osedd-active', '1');
        } else {
          thumb.removeAttribute('data-osedd-active');
        }
      });

      var activeThumb = thumbs[index];

      if (
        activeThumb &&
        typeof activeThumb.scrollIntoView === 'function'
      ) {
        activeThumb.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'nearest'
        });
      }

      syncMainNav();
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var i = Number(
          thumb.getAttribute('data-osedd-gal-index') || 0
        );

        setActive(i);
      });
    });

    if (mainPrev) {
      mainPrev.addEventListener('click', function (e) {
        e.preventDefault();
        setActive(index - 1);
      });
    }

    if (mainNext) {
      mainNext.addEventListener('click', function (e) {
        e.preventDefault();
        setActive(index + 1);
      });
    }

    if (thumbViewport) {
      thumbViewport.style.scrollBehavior = 'smooth';
    }

    setActive(0);
  }

  function initFlavorForm(root) {
    if (!root || root.__osmbFlavorInit) return;
    root.__osmbFlavorInit = true;

    var required = toInt(root.getAttribute('data-default-required'), 1);
    var maxQty = toInt(root.getAttribute('data-max-qty'), 3);
    var planMode = String(root.getAttribute('data-plan-mode') || 'subscription').toLowerCase();
    var isOtp = planMode === 'otp' || planMode === 'one-time' || planMode === 'onetime';

    var plan1 = root.getAttribute('data-plan-1') || '';
    var plan2 = root.getAttribute('data-plan-2') || '';
    var plan3 = root.getAttribute('data-plan-3') || '';

    var freebies1 = root.getAttribute('data-freebies-1') || '';
    var freebies2 = root.getAttribute('data-freebies-2') || '';
    var freebies3 = root.getAttribute('data-freebies-3') || '';

    var disc1 = root.getAttribute('data-discount-1') || '';
    var disc2 = root.getAttribute('data-discount-2') || '';
    var disc3 = root.getAttribute('data-discount-3') || '';

    var clearCart = (root.getAttribute('data-clear-cart') || 'true') === 'true';
    var baseCTAPrice = parseFloat(String(root.getAttribute('data-base-cta-price') || '').replace(/[^0-9.]/g, '')) || 0;
    var baseCTAComparePrice = parseFloat(String(root.getAttribute('data-base-compare-price') || '').replace(/[^0-9.]/g, '')) || 0;
    var baseCTAComparePrice2 = parseFloat(String(root.getAttribute('data-base-compare-price-2') || '').replace(/[^0-9.]/g, '')) || 0;
    var baseRecurringPrice = parseFloat(String(root.getAttribute('data-base-recurring-price') || '').replace(/[^0-9.]/g, '')) || 0;
    var baseSubSchedule = String(root.getAttribute('data-base-sub-schedule') || '').trim();

    var titleEl = qs(root, '[data-osjf-title]');
    var subEl = qs(root, '[data-osjf-sub]');
    var noteEl = qs(root, '[data-osjf-note]');
    var errorEl = qs(root, '[data-osjf-error]');
    var ctaBtn = qs(root, '[data-osjf-cta]');
    var ctaLeft = qs(root, '[data-osjf-cta-left]');
    var refillNoteEl = qs(root, '[data-osmb-refill-note]');
    var progressTextEl = qs(root, '[data-osjf-progress-text]');
    var barFillEl = qs(root, '[data-osjf-bar-fill]');
    var backBtn = qs(root, '[data-osjf-back]');
    var itemEls = qsa(root, '[data-osjf-item]');

    var readyText = 'Proceed to Checkout';
    var readyTextSetting = root.querySelector('[data-osjf-cta-left]');
    if (readyTextSetting && readyTextSetting.dataset.readyText) {
      readyText = readyTextSetting.dataset.readyText;
    }

    var state = {
      required: Math.max(1, required),
      max: Math.max(required, maxQty),
      counts: {},
      total: 0
    };

    function getSellingPlanIdForQty(qty) {
      if (isOtp) return '';

      var cleanQty = toInt(qty, 0);

      if (cleanQty <= 1) {
        return plan1 || '';
      }

      if (cleanQty === 2) {
        return plan2 || plan1 || '';
      }

      return plan3 || '';
    }

    function getSellingPlanMeta() {
      if (isOtp) {
        return {
          plan1: '',
          plan2: '',
          plan3: ''
        };
      }

      return {
        plan1: plan1 || '',
        plan2: plan2 || '',
        plan3: plan3 || ''
      };
    }

    function recalcTotal() {
      var total = 0;

      Object.keys(state.counts).forEach(function (variantId) {
        total += toInt(state.counts[variantId], 0);
      });

      state.total = total;
    }

    function setHeader() {
      if (titleEl) {
        titleEl.textContent =
          root.getAttribute('data-form-heading') || 'BUY MORE, SAVE MORE → ADD 2 OR MORE';
      }

      if (subEl) {
        subEl.textContent = isOtp
          ? 'Try it once. Pick your flavors.'
          : 'Subscribe & save. Pick your flavors.';
      }

      if (noteEl) {
        noteEl.textContent = isOtp
          ? 'No autoship. You can check out once you’ve selected ' + state.required + ' bag' + (state.required === 1 ? '.' : 's.')
          : 'Subscription will be applied at checkout.';
      }
    }

    function escapeHtml(str) {
      return String(str || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function normalizeCtaQty(total) {
      if (total <= 1) return 1;
      if (total === 2) return 2;
      return 3;
    }

    function formatPrice(n) {
      return '$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2));
    }

    function getCtaPriceData(total) {
      var cleanTotal = toInt(total, 0);

      if (cleanTotal >= 4 && baseCTAPrice > 0) {
        var computedPrice = baseCTAPrice * cleanTotal;
        var computedCompare = 0;
        if (baseCTAComparePrice > 0) {
          computedCompare = baseCTAComparePrice + (baseCTAComparePrice2 > 0 ? baseCTAComparePrice2 * (cleanTotal - 3) : 0);
        }
        var perBottleStr = formatPrice(baseCTAPrice) + ' per bottle';

        return {
          prefix: root.getAttribute('data-cta-price-prefix') || 'TRY ONE SOL TODAY',
          compare: computedCompare > 0 ? formatPrice(computedCompare) : '',
          price: formatPrice(computedPrice),
          perBottle: perBottleStr,
          computed: false
        };
      }

      var qty = normalizeCtaQty(cleanTotal);

      return {
        prefix: root.getAttribute('data-cta-price-prefix') || 'TRY ONE SOL TODAY',
        compare: root.getAttribute('data-cta-compare-' + qty) || '',
        price: root.getAttribute('data-cta-price-' + qty) || '',
        perBottle: root.getAttribute('data-cta-per-bottle-' + qty) || '',
        computed: false
      };
    }

    function renderPerBottleHtml(perBottleText) {
      var cleanText = String(perBottleText || '').trim();
      if (!cleanText) return '';

      var raw = escapeHtml(cleanText);
      var value = raw;
      var label = '';
      var lower = raw.toLowerCase();
      var perIndex = lower.indexOf(' per ');

      if (perIndex >= 0) {
        value = raw.slice(0, perIndex);
        label = raw.slice(perIndex + 1).trim();
      }

      var match = value.match(/^(\$?\d+)\.(\d{2})$/);
      if (match) {
        value = match[1] + '<sup>' + match[2] + '</sup>';
      }

      return (
        '<span class="osjf-cta-offer__perBottle">' +
          '<span class="osjf-cta-offer__perBottleValue">' + value + '</span>' +
          (label ? '<span class="osjf-cta-offer__perBottleLabel">' + label + '</span>' : '') +
        '</span>'
      );
    }

    function renderCtaOfferHtml(total) {
      var data = getCtaPriceData(total);

      return (
        '<span class="osjf-cta-offer">' +
          '<span class="osjf-cta-offer__prefix">' + escapeHtml(data.prefix) + '</span>' +
          '<span class="osjf-cta-offer__arrow" aria-hidden="true">→</span>' +
          (data.compare ? '<span class="osjf-cta-offer__compare">' + escapeHtml(data.compare) + '</span>' : '') +
          (data.price ? '<span class="osjf-cta-offer__price">' + escapeHtml(data.price) + '</span>' : '') +
          renderPerBottleHtml(data.perBottle) +
        '</span>'
      );
    }

    function getRefillNoteText(total) {
      var cleanTotal = toInt(total, 0);

      if (cleanTotal <= 0) {
        return '';
      }

      if (cleanTotal >= 4 && baseRecurringPrice > 0) {
        var computedRecurring = baseRecurringPrice * cleanTotal;
        var formattedRecurring = '$' + computedRecurring.toFixed(2);
        var schedule = baseSubSchedule || 'every 30 days';
        return 'Then ' + formattedRecurring + ' refills ' + schedule + '.';
      }

      var qty = normalizeCtaQty(cleanTotal);
      var note = root.getAttribute('data-refill-note-' + qty) || '';

      if (!note && qty === 3) {
        note = root.getAttribute('data-refill-note-2') || root.getAttribute('data-refill-note-1') || '';
      }

      if (!note && qty === 2) {
        note = root.getAttribute('data-refill-note-1') || '';
      }

      return String(note || '').trim();
    }

    function updateRefillNote() {
      if (!refillNoteEl) return;

      var noteText = getRefillNoteText(state.total);

      if (!noteText) {
        refillNoteEl.textContent = '';
        refillNoteEl.hidden = true;
        return;
      }

      refillNoteEl.textContent = noteText;
      refillNoteEl.hidden = false;
    }

    function updateUI() {
      recalcTotal();

      itemEls.forEach(function (row) {
        if (row.getAttribute('data-sold-out') === '1') return;

        var vid = row.getAttribute('data-variant-id');
        var qtyEl = qs(row, '[data-osjf-row-qty]');
        var minusBtn = qs(row, '[data-osjf-minus]');
        var plusBtn = qs(row, '[data-osjf-plus]');
        var qty = toInt(state.counts[vid], 0);

        if (qtyEl) qtyEl.textContent = String(qty);
        if (minusBtn) minusBtn.disabled = qty <= 0;
        if (plusBtn) plusBtn.disabled = state.total >= state.max;
      });

      var pct = state.max > 0 ? Math.min(100, Math.round((state.total / state.max) * 100)) : 0;

      if (barFillEl) {
        barFillEl.style.width = pct + '%';
      }

      if (progressTextEl) {
        progressTextEl.textContent = state.total + '/' + state.max + ' selected';
      }

      updateRefillNote();

      if (errorEl && state.total > 0) {
        errorEl.textContent = '';
      }

      var canCheckout = state.total >= state.required;
      var idleText = '';

      if (ctaLeft) {
        idleText =
          ctaLeft.getAttribute('data-idle-text') ||
          root.getAttribute('data-form-cta-idle') ||
          'CHOOSE YOUR FLAVOR';
      }

      if (ctaBtn) {
        ctaBtn.disabled = false;
        ctaBtn.classList.toggle('has-selection', state.total > 0);
        ctaBtn.classList.toggle('is-ready', canCheckout);
        ctaBtn.classList.toggle('is-idle', state.total <= 0);

        if (ctaLeft) {
          if (state.total <= 0) {
            ctaLeft.textContent = idleText;
          } else {
            ctaLeft.innerHTML = renderCtaOfferHtml(state.total);
          }
        }
      }
    }

    function setBusy(isBusy) {
      if (!ctaBtn) return;

      ctaBtn.disabled = !!isBusy;
      ctaBtn.setAttribute('aria-busy', isBusy ? 'true' : 'false');

      if (isBusy) {
        ctaBtn.classList.add('is-busy');
        if (ctaLeft) {
          ctaLeft.innerHTML =
            '<span class="osjf-cta-spinner" aria-hidden="true">' +
              '<svg class="osjf-cta-spinner-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">' +
                '<circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" stroke-dasharray="40" stroke-dashoffset="10" stroke-linecap="round"/>' +
              '</svg>' +
            '</span>';
        }
      } else {
        ctaBtn.classList.remove('is-busy');
      }
    }

    itemEls.forEach(function (row) {
      var vid = row.getAttribute('data-variant-id');
      var minusBtn = qs(row, '[data-osjf-minus]');
      var plusBtn = qs(row, '[data-osjf-plus]');
      var isSoldOut = row.getAttribute('data-sold-out') === '1';

      if (!vid || isSoldOut) return;

      state.counts[vid] = 0;

      if (minusBtn) {
        minusBtn.addEventListener('click', function () {
          var current = toInt(state.counts[vid], 0);
          state.counts[vid] = Math.max(0, current - 1);
          updateUI();
        });
      }

      if (plusBtn) {
        plusBtn.addEventListener('click', function () {
          if (state.total >= state.max) return;

          var current = toInt(state.counts[vid], 0);
          state.counts[vid] = current + 1;
          updateUI();
        });
      }
    });

    if (backBtn) {
      backBtn.addEventListener('click', function () {
        closeForm(root);
      });
    }

    if (ctaBtn) {
      ctaBtn.addEventListener('click', function () {
        if (root.__osmbSubmitting) return;

        recalcTotal();

        if (state.total < state.required) {
          updateUI();

          if (errorEl) {
            errorEl.textContent = 'Please choose at least 1 flavor.';
          }

          var firstPlusBtn = qs(root, '[data-osjf-plus]');
          if (firstPlusBtn) {
            firstPlusBtn.focus({ preventScroll: true });
          }

          return;
        }

        root.__osmbSubmitting = true;
        setBusy(true);

        if (errorEl) errorEl.textContent = '';

        var selectedPlanId = getSellingPlanIdForQty(state.total);
        var selectedPlanMeta = getSellingPlanMeta();
        var baseItems = buildItemsFromState(state, selectedPlanId, selectedPlanMeta);
        var freebieItems = getFreebieItemsForTotal(state.total, freebies1, freebies2, freebies3);
        var items = mergeItems(baseItems, freebieItems);

        var codes = getDiscountCodesForTotal(state.total, disc1, disc2, disc3);
        var bogoConfig = getBogoConfig(root);
        var bogoParams = normalizeBogoParamString(bogoConfig.params);
        var bogoEnabled = bogoConfig.enabled && !!bogoParams;
        var bogoAttributes = bogoEnabled
          ? extractBogoCartAttributes(root)
          : null;
        var checkoutPath = bogoEnabled
          ? getCheckoutUrlWithCurrentParams(root)
          : '/checkout';
        var redirectUrl =
          buildDiscountRedirectUrl(codes, checkoutPath) ||
          checkoutPath;
        var cartBeforeAdd = null;
        var cartAfterAdd = null;
        var cartAfterAttributeUpdate = null;
        var addedQuantity = getItemsQuantity(items);

        Promise.resolve()
          .then(function () {
            if (clearCart) {
              return postJSON('/cart/clear.js', {}).then(function () {
                return wait(180);
              });
            }
          })
          .then(function () {
            if (!bogoEnabled) return null;

            return fetchCart()
              .then(function (cart) {
                cartBeforeAdd = cart;
                return cart;
              })
              .catch(function () {
                cartBeforeAdd = null;
                return null;
              });
          })
          .then(function () {
            return postJSON('/cart/add.js', {
              items: items
            });
          })
          .then(function () {
            if (!bogoEnabled) return null;

            return fetchCart()
              .then(function (cart) {
                cartAfterAdd = cart;
                return cart;
              })
              .catch(function () {
                cartAfterAdd = null;
                return null;
              });
          })
          .then(function () {
            if (!bogoAttributes) return null;

            return postJSON('/cart/update.js', {
              attributes: bogoAttributes
            }).then(function (cart) {
              cartAfterAttributeUpdate = cart;
              return cart;
            });
          })
          .then(function () {
            if (!bogoAttributes) return null;

            var latestCart =
              cartAfterAttributeUpdate ||
              cartAfterAdd ||
              null;

            var knownItemCount =
              latestCart &&
              typeof latestCart.item_count === 'number'
                ? latestCart.item_count
                : null;

            var baselineItemCount =
              cartBeforeAdd &&
              typeof cartBeforeAdd.item_count === 'number'
                ? cartBeforeAdd.item_count
                : null;

            var giftAlreadyPresent =
              knownItemCount !== null &&
              baselineItemCount !== null &&
              knownItemCount >
                baselineItemCount + addedQuantity;

            if (
              !giftAlreadyPresent &&
              knownItemCount !== null
            ) {
              return waitForBogoGift(knownItemCount);
            }

            return null;
          })
          .then(function () {
            if (bogoEnabled) {
              applyBogoUrlParams(root);
            }

            window.location.href = redirectUrl;
          })
          .catch(function (err) {
            var msg = err && err.message ? err.message : 'Unable to start checkout. Please try again.';

            if (errorEl) {
              errorEl.textContent = msg;
            }

            root.__osmbSubmitting = false;
            setBusy(false);
            updateUI();
          });
      });
    }

    setHeader();
    updateUI();
  }

  function getSyncRole(root) {
    return root
      ? String(
          root.getAttribute('data-osmb-sync-role') ||
          'standalone'
        ).trim()
      : 'standalone';
  }

  function getSyncGroup(root) {
    return root
      ? String(
          root.getAttribute('data-osmb-sync-group') ||
          ''
        ).trim()
      : '';
  }

  function rewriteSyncedIds(
    root,
    sourceSectionId,
    targetSectionId
  ) {
    if (
      !root ||
      !sourceSectionId ||
      !targetSectionId ||
      sourceSectionId === targetSectionId
    ) {
      return;
    }

    var idMap = {};

    qsa(root, '[id]').forEach(function (element) {
      var oldId = element.id;

      if (
        !oldId ||
        oldId.indexOf(sourceSectionId) === -1
      ) {
        return;
      }

      var newId = oldId
        .split(sourceSectionId)
        .join(targetSectionId);

      element.id = newId;
      idMap[oldId] = newId;
    });

    var idReferenceAttributes = [
      'aria-controls',
      'aria-labelledby',
      'aria-describedby',
      'for'
    ];

    qsa(root, '*').forEach(function (element) {
      idReferenceAttributes.forEach(function (attributeName) {
        var rawValue = element.getAttribute(attributeName);
        if (!rawValue) return;

        var nextValue = rawValue
          .split(/\s+/)
          .map(function (value) {
            return idMap[value] || value;
          })
          .join(' ');

        if (nextValue !== rawValue) {
          element.setAttribute(attributeName, nextValue);
        }
      });

      var href = element.getAttribute('href');
      if (!href || href.charAt(0) !== '#') return;

      var referencedId = href.slice(1);

      if (idMap[referencedId]) {
        element.setAttribute(
          'href',
          '#' + idMap[referencedId]
        );
      }
    });
  }

  function removeCopiedEditorBlockAttributes(root) {
    if (!root) return;

    qsa(root, '[data-shopify-editor-block]').forEach(
      function (element) {
        element.removeAttribute(
          'data-shopify-editor-block'
        );
      }
    );
  }

  function cleanUpRootBeforeSync(root) {
    if (!root) return;

    if (
      root.__osmbStickyObs &&
      typeof root.__osmbStickyObs.disconnect === 'function'
    ) {
      root.__osmbStickyObs.disconnect();
    }

    qsa(root, '[data-osmb-offer-lottie]').forEach(
      function (iconEl) {
        if (
          !iconEl.__osmbOfferLottieAnim ||
          typeof iconEl.__osmbOfferLottieAnim.destroy !==
            'function'
        ) {
          return;
        }

        try {
          iconEl.__osmbOfferLottieAnim.destroy();
        } catch (e) {}

        iconEl.__osmbOfferLottieAnim = null;
      }
    );
  }

  function revealSyncCopy(root) {
    if (!root) return;

    root.style.removeProperty('visibility');
    root.setAttribute('data-osmb-sync-ready', 'true');
  }

  function copyRootAttributes(source, target) {
    var targetScrollId =
      target.getAttribute('id') || '';

    var preservedAttributes = {
      'data-osmb-section-id':
        target.getAttribute('data-osmb-section-id') || '',
      'data-osmb-sync-role':
        target.getAttribute('data-osmb-sync-role') ||
        'copy',
      'data-osmb-sync-group':
        target.getAttribute('data-osmb-sync-group') || '',
      'data-osmb-sync-ready':
        target.getAttribute('data-osmb-sync-ready') ||
        'false'
    };

    Array.prototype.slice
      .call(target.attributes)
      .forEach(function (attribute) {
        target.removeAttribute(attribute.name);
      });

    Array.prototype.slice
      .call(source.attributes)
      .forEach(function (attribute) {
        target.setAttribute(
          attribute.name,
          attribute.value
        );
      });

    Object.keys(preservedAttributes).forEach(
      function (attributeName) {
        target.setAttribute(
          attributeName,
          preservedAttributes[attributeName]
        );
      }
    );

    if (targetScrollId) {
      target.setAttribute('id', targetScrollId);
    } else {
      target.removeAttribute('id');
    }
  }

  function resetCopiedRuntimeState(root) {
    if (!root) return;

    root.classList.remove(
      'osedd-sticky-active',
      'is-form-open'
    );

    var offerView = qs(root, '[data-osmb-offer-view]');
    var formView = qs(root, '[data-osmb-form-view]');

    if (offerView) offerView.hidden = false;
    if (formView) formView.hidden = true;

    qsa(root, '[data-osmb-offer-dates]').forEach(
      function (datesWrap) {
        datesWrap.removeAttribute(
          'data-osmb-dates-init'
        );
      }
    );
  }

  function syncRootFromSource(source, target) {
    if (!source || !target || source === target) return;

    var sourceSectionId =
      source.getAttribute('data-osmb-section-id') || '';

    var targetSectionId =
      target.getAttribute('data-osmb-section-id') || '';

    cleanUpRootBeforeSync(target);
    copyRootAttributes(source, target);

    target.innerHTML = source.innerHTML;

    rewriteSyncedIds(
      target,
      sourceSectionId,
      targetSectionId
    );

    removeCopiedEditorBlockAttributes(target);
    resetCopiedRuntimeState(target);

    // Keep one fixed sticky CTA per sync group.
    // The Master owns the sticky CTA.
    var copiedSticky = qs(
      target,
      '[data-osedd-sticky]'
    );

    if (copiedSticky) copiedSticky.remove();

    target.__osmbBound = false;
    target.__osmbStickyObserved = false;
    target.__osmbStickyObs = null;
    target.__osmbFlavorInit = false;
    target.__osmbSubmitting = false;

    revealSyncCopy(target);
  }

  function syncBuyBoxCopies() {
    var roots = qsa(document, ROOT_SELECTOR);
    var sourcesByGroup = {};

    roots.forEach(function (root) {
      if (getSyncRole(root) !== 'source') return;

      var group = getSyncGroup(root);
      if (!group) return;

      if (sourcesByGroup[group]) {
        console.warn(
          'OS EDD Mix Bundle found more than one Master in sync group "' +
            group +
            '". The first Master on the page will be used.'
        );

        return;
      }

      sourcesByGroup[group] = root;
    });

    roots.forEach(function (root) {
      if (getSyncRole(root) !== 'copy') return;

      var group = getSyncGroup(root);
      var source = group
        ? sourcesByGroup[group]
        : null;

      if (!source) {
        revealSyncCopy(root);

        if (!root.__osmbMissingSyncSourceWarned) {
          var missingGroupName = group || '(blank)';

          console.warn(
            'OS EDD Mix Bundle Copy could not find a Master in sync group "' +
              missingGroupName +
              '". Its own section settings will be used instead.'
          );

          root.__osmbMissingSyncSourceWarned = true;
        }

        return;
      }

      syncRootFromSource(source, root);
    });
  }

  function initGalleryWithoutPageJump(root) {
    if (getSyncRole(root) !== 'copy') {
      initGallery(root);
      return;
    }

    // The existing gallery calls scrollIntoView() while it
    // selects the first thumbnail. Temporarily removing the
    // Copy from layout prevents that initialization call from
    // scrolling the full page to a lower synced buy box.
    var previousDisplay = root.style.display;

    root.style.display = 'none';

    try {
      initGallery(root);
    } finally {
      if (previousDisplay) {
        root.style.display = previousDisplay;
      } else {
        root.style.removeProperty('display');
      }
    }
  }

  function bindRoot(root) {
    if (!root || root.__osmbBound) return;
    root.__osmbBound = true;

    var mainOpenButtons = qsa(
      root,
      '[data-osmb-open-form]'
    );

    mainOpenButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var isStickyBtn = btn.hasAttribute(
          'data-osedd-sticky-cta'
        );

        if (
          isStickyBtn &&
          root.classList.contains('is-form-open')
        ) {
          var card = qs(
            root,
            '[data-osmb-offer-card]'
          );

          smoothScrollToTarget(
            card ||
              qs(root, '[data-osmb-form-view]')
          );

          return;
        }

        openForm(root, btn);
      });
    });

    var mainCta = qs(
      root,
      '[data-osmb-open-form]:not([data-osedd-sticky-cta])'
    );

    // Copies have their cloned sticky CTA removed.
    if (
      mainCta &&
      qs(root, '[data-osedd-sticky]')
    ) {
      bindStickyObserver(root, mainCta);
    }

    bindInfoDropdowns(root);
    bindRteScrollLinks(root);
    initGalleryWithoutPageJump(root);
    initFlavorForm(root);
    initOSMB_OfferLottie(root);
    initOSMB_OfferDates(root);
  }

  function initAll() {
    syncBuyBoxCopies();

    var roots = qsa(document, ROOT_SELECTOR);
    var bogoRoot = null;

    roots.some(function (root) {
      var config = getBogoConfig(root);

      if (
        config.enabled &&
        normalizeBogoParamString(config.params)
      ) {
        bogoRoot = root;
        return true;
      }

      return false;
    });

    if (
      bogoRoot &&
      applyBogoUrlParams(
        bogoRoot,
        { allowReload: true }
      )
    ) {
      return;
    }

    roots.forEach(bindRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initAll,
      { once: true }
    );
  } else {
    initAll();
  }

  document.addEventListener(
    'shopify:section:load',
    initAll
  );
})();